import Vue from 'vue'
import { differenceInDays } from 'date-fns'
import uniqid from 'uniqid'
import { toSlug } from '@/utils/slug'
import { cropUrl, logoUrl, webpCropUrl } from '@/utils/images'
import { withInternalLinksInSameTab } from '@/utils/richContentLinks'

function truncateHtml(html, maxLength, options = {}) {
  if (!html || typeof html !== 'string') return ''
  const ellipsis = options.ellipsis || '...'

  const tagStack = []
  let charCount = 0
  let result = ''
  let i = 0

  while (i < html.length && charCount < maxLength) {
    if (html[i] === '<') {
      const tagEnd = html.indexOf('>', i)
      if (tagEnd === -1) break

      const tag = html.slice(i, tagEnd + 1)
      const isClosingTag = tag[1] === '/'
      const isSelfClosing =
        tag[tag.length - 2] === '/' ||
        /^<(br|hr|img|input|meta|link)/i.test(tag)

      if (isClosingTag) {
        tagStack.pop()
      } else if (!isSelfClosing) {
        const tagName = tag.match(/^<(\w+)/)?.[1]
        if (tagName) tagStack.push(tagName)
      }

      result += tag
      i = tagEnd + 1
    } else if (html[i] === '&') {
      const entityEnd = html.indexOf(';', i)
      if (entityEnd !== -1 && entityEnd - i < 10) {
        result += html.slice(i, entityEnd + 1)
        i = entityEnd + 1
        charCount++
      } else {
        result += html[i]
        i++
        charCount++
      }
    } else {
      result += html[i]
      i++
      charCount++
    }
  }

  if (charCount >= maxLength && i < html.length) {
    result = result.trimEnd() + ellipsis
  }

  while (tagStack.length > 0) {
    result += `</${tagStack.pop()}>`
  }

  return result
}

export default function (context) {
  Vue.prototype.$filteringArraysByIds = function (
    filtered_array,
    tested_array
  ) {
    if (tested_array) {
      return filtered_array.filter(
        i => !tested_array.map(obj => obj.id).includes(i.id)
      )
    } else {
      return filtered_array
    }
  }

  Vue.prototype.$removeDuplicateObjects = function (array, key) {
    let filtered_array = Array.from(new Set(array.map(a => a[key]))).map(
      item_key => {
        return array.find(a => a[key] === item_key)
      }
    )

    return filtered_array
  }

  Vue.prototype.$daysBetweenTwoDates = function (date_from, date_to) {
    return differenceInDays(new Date(date_to), new Date(date_from))
  }

  Vue.prototype.$slugify = toSlug

  Vue.prototype.$uniqid = uniqid

  Vue.prototype.$cropUrl = cropUrl

  Vue.prototype.$logoUrl = logoUrl

  Vue.prototype.$webpCropUrl = webpCropUrl

  Vue.prototype.$getTva = function (number) {
    return (number / 100) * 20
  }

  Vue.prototype.$hasRole = function (role) {
    if (
      context.app.store.$auth.user &&
      context.app.store.$auth.user.user_type &&
      role.includes(context.app.store.$auth.user.user_type.identifier)
    ) {
      return true
    } else {
      return false
    }
  }

  Vue.prototype.$richContent = function (html) {
    return withInternalLinksInSameTab(html, context.$config.url)
  }

  Vue.prototype.$cleanEditorText = function (text) {
    return text.replace(
      /<p class="ql-align-justify"><br><\/p>|<p><br><\/p>|<p style="text-align: center;"><br><\/p>/g,
      ''
    )
  }

  Vue.prototype.$truncateHtml = function (string, length, options = {}) {
    if (!string) return ''
    let result = string
    if (options.stripTags?.length) {
      const tagsPattern = options.stripTags.join('|')
      result = result.replace(
        new RegExp(`<\\/?(${tagsPattern})\\b[^>]*>`, 'gi'),
        ''
      )
    }
    return truncateHtml(result, length, { ellipsis: '...' })
  }

  Vue.prototype.$delay = function (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  Vue.prototype.$sortByAlpha = function (array) {
    return array
      .filter(item => item.name)
      .sort((a, b) => {
        const textA = a.name.toUpperCase()
        const textB = b.name.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
  }
}
